import React from 'react';
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import DtvBox from '@directv-digital/dds.ui.dtv-box';
import DtvText from '@directv-digital/dds.ui.dtv-text';
import { pkgStyles, channelColWidthStyle, channelLabelColWidthStyle } from '../PackageCmprGrid.styles';
import { colorPalette } from "@directv-digital/dds.ui.dtv-theme";

export const PriceRow = (props: any) => {
  try {
    const { accIndex, priceData } = props;
    return (<DtvBox
            id={`apct-price-row-container-${accIndex}`}
            key={`apct-price-row-container-${accIndex}`}
            sx={{
                display: "flex",
                width: "100%",
                flexDirection: "row",
                ...pkgStyles.priceRow
            }}
        >{priceData && priceData?.map((val, index) => (
                <DtvBox
                    id={`apct-price-row-${accIndex}-${index}`}
                    key={`apct-price-row-${accIndex}-${index}`}
                    sx={{
                        display: "flex",
                        width: "100%",
                        flexDirection: "row",
                        ...pkgStyles.priceRow,
                        border: `1px solid ${colorPalette.neutral[400]}`
                    }}
                >
                    <DtvBox
                        id={`apct-price-label-${val?.label}-${index}`}
                        key={`apct-price-label-${val?.label}-${index}`}
                        sx={{
                            ...channelLabelColWidthStyle,
                            ...pkgStyles?.priceLabelContainer,
                            borderRight: `1px solid ${colorPalette.neutral[400]}`,
                            width: {
 xs: "105px",
sm: "175px",
md: "255px"
},
                            minWidth: {
 xs: "105px",
sm: "175px",
md: "255px"
}
                        }}
                    >
                        <DtvText
                            content={val?.label}
                            variant={"body2medium"}
                            sx={{ fontSize: '16px !important' }}
                        />
                    </DtvBox>

                    {val?.priceDetails && val?.priceDetails.length > 0 && val?.priceDetails.map((price: any, priceIndex: any) => {
                        const tempPrice = price;
                        return (<DtvBox
                            id={`pricerow-box-${index}-${priceIndex}`}
                            key={`pricerow-box-${index}-${priceIndex}`}
                            sx={{
                                ...channelColWidthStyle,
                                ...pkgStyles?.pricesBox,
                                // borderLeft: `1px solid ${colorPalette.neutral[400]}`,
                                borderRight: priceIndex !== val.priceDetails.length - 1 ? `1px solid ${colorPalette.neutral[400]}` : 'none',
                                textWrap: "wrap",
                                padding: {
                                    xs: price.strikeoutPrice ? "11px" : "20px 10px",
                                    sm: price.strikeoutPrice ? "11px 20px" : "25px 20px"
                                }
                            }}
                        >
                            {price.strikeoutPrice && (
                                <>
                                    {/* Desktop strikeout */}
                                    <DtvText
                                        content={price.strikeoutPrice}
                                        variant={"body3medium"}
                                        sx={{
                                            ...pkgStyles?.priceLabelText,
                                            textDecoration: "line-through",
                                            marginBottom: "2px"
                                        }}
                                    />
                                    {/* Mobile strikeout */}
                                    <DtvText
                                        content={price.strikeoutPrice}
                                        variant={"body3medium"}
                                        sx={{
                                            ...pkgStyles?.priceLabelMobileText,
                                            textDecoration: "line-through",
                                            marginBottom: "2px"
                                        }}
                                    />
                                </>
                            )}
                            {/* Main price */}
                            <DtvText
                                content={price.mainPrice || ""}
                                variant={"body2medium"}
                                sx={{
                                    ...pkgStyles?.priceLabelText,
                                    fontSize: price.strikeoutPrice ? "14px !important" : "16px !important"
                                }}
                            />
                            <>
                                <DtvText
                                    content={tempPrice?.mainPrice ? tempPrice.mainPrice.replace("/mo.", "").trim() : ""}
                                    variant={"body2medium"}
                                    sx={{
                                        ...pkgStyles?.priceLabelMobileText
                                    }}
                                />
                                {tempPrice?.mainPrice && (
                                    <DtvText
                                        content={"/mo."}
                                        variant={"body2medium"}
                                        sx={{
                                            ...pkgStyles?.priceLabelMobileText,
                                            fontSize: "10px",
                                            marginTop: "-2px"
                                        }}
                                    />
                                )}
                            </>
                        </DtvBox>)
                    })}
                </DtvBox>
            ))}</DtvBox>)
  } catch (error) {
    console.error("Error in Customer Acq Compare Tool - Price Row >> ", error);
    return <ErrorDisplay component="Customer Acq Compare Tool -> Price row" error={error} />;
  }
}
